__webpack_require__.p = "/Electoral-system/";